// The chip styles the dashboard needs that the design-system Pill can't express: a solid-danger fill with
// white text, an outlined neutral, and the premium/success/soft-danger fills. Each variant maps to a set of
// design-system classes inside the component, mirroring the buyer-side ticket-card chips
// (App\Libraries\Facades\Event\EventTicketing\Enums\AttendanceStatus / PaymentStatus get*Class()).
export enum TicketingStatusPillVariant {
  PREMIUM = 'PREMIUM',
  SUCCESS = 'SUCCESS',
  NEUTRAL = 'NEUTRAL',
  NEUTRAL_OUTLINED = 'NEUTRAL_OUTLINED',
  SOFT_DANGER = 'SOFT_DANGER',
  SOLID_DANGER = 'SOLID_DANGER',
}

export interface TicketingStatusPillProps {
  variant: TicketingStatusPillVariant;
  label: string;
  // A leading icon-font class (e.g. 'icon-check'); omitted for a label-only pill.
  icon?: string;
  // An optional leading count chip rendered inside the pill in the variant's solid tone (e.g. "1 of 2" before
  // "Checked in" on a partially-checked-in order). When set, the pill hugs it flush-left and the icon is usually omitted.
  countBadge?: string;
}
